import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Button from "components/Button/Button";
import searchIcon from "images/pattern/search.svg";
import JobCard from "components/Card/JobCard";
import cornerYellow from "images/pattern/corner-yellow.svg";
import edgeRed from "images/pattern/edge-red.svg";
import Pagination from "@mui/material/Pagination";
import actionApi from "services/actionApi";
import makeToast from "utils/toast/makeToast";
import { useSearchParams } from "react-router-dom";
import notFoundIcon from "images/icon/not-found.png";

const ITEM_PER_PAGE = 10;

const JobExpoPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [jobs, setJobs] = useState([]);
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [page, setPage] = useState(1);
  const { register, watch, setValue } = useForm();
  const [searchParams, setSearchParams] = useSearchParams();

  const totalPage = Math.ceil(filteredJobs?.length / ITEM_PER_PAGE);
  const startIndex = (page - 1) * ITEM_PER_PAGE;
  const endIndex = startIndex + ITEM_PER_PAGE;
  const shownJobs = filteredJobs.slice(startIndex, endIndex);

  const screenWidth = window.innerWidth;

  useEffect(() => {
    actionApi
      .jobExpo()
      .then((response) => {
        const jobs = response?.data?.data;
        setJobs(jobs);
        setFilteredJobs(jobs);
      })
      .catch(() => {
        makeToast({ label: "Error while fetching data", type: "error" });
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    const searchKey = searchParams.get("search");
    if (!searchKey) {
      return;
    }
    setValue("searchKey", searchKey);
    handleFilter(searchKey);
  }, [searchParams, jobs]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const searchKey = watch("searchKey");
    handleFilter(searchKey);
  };

  const handleFilter = (searchKey) => {
    const cleanKey = searchKey?.trim();
    setPage(1);
    setSearchParams({ search: cleanKey });
    if (!cleanKey) {
      setValue("searchKey", "");
      setFilteredJobs(jobs);
      return;
    }
    setFilteredJobs(
      jobs.filter(
        (j) =>
          j?.positionTitle.toLowerCase().includes(cleanKey.toLowerCase()) ||
          j?.companyName.toLowerCase().includes(cleanKey.toLowerCase())
      )
    );
  };

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  return (
    <div className="bg-wce-pink-light py-8 md:py-24 px-6 md:px-8 w-full mx-auto relative overflow-hidden">
      <div className="absolute top-0 right-0  z-0">
        <img
          className="w-[158px] min-w-[158px]"
          src={cornerYellow}
          alt={"cornerYellow"}
        />
      </div>
      <div className="absolute top-[600px] left-0 z-0">
        <img
          className="w-[158px] min-w-[158px]"
          src={edgeRed}
          alt={"edgeRed"}
        />
      </div>
      <div className="max-w-7xl flex flex-col mx-auto items-center">
        <div className="text-5xl font-yesevaOne text-wce-navy mb-14 z-10">
          Job Expo
        </div>
        <form onSubmit={handleSubmit} className="flex gap-4 w-full mb-8  z-10">
          <div className="w-full relative">
            <img
              src={searchIcon}
              alt={"searchIcon"}
              className="absolute top-1/2 -translate-y-1/2 left-4"
            />
            <input
              className={`border border-wce-neutral-5 py-2 pr-4 pl-12 rounded-2xl w-full`}
              {...register("searchKey")}
              placeholder="Insert keywords"
            />
          </div>
          <Button size="large" rounded className={"w-[160px]"} type="submit">
            Search
          </Button>
        </form>
        {!isLoading ? (
          shownJobs?.length > 0 ? (
            <>
              <div className="flex flex-col w-full gap-4 z-10">
                {shownJobs.map((j) => (
                  <JobCard job={j} />
                ))}
              </div>
              <div className="mt-8">
                <Pagination
                  size={screenWidth < 640 ? "small" : "large"}
                  count={totalPage}
                  page={page}
                  onChange={handleChangePage}
                />
              </div>
            </>
          ) : (
            <div className="flex flex-col items-center mt-10 sm:mt-20">
              <img
                src={notFoundIcon}
                alt="not-found"
                className="w-[124px] h-[124px]"
              />
              <div className="mt-6 text-wce-neutral-10">
                We couldn’t find any jobs matching that search.
              </div>
            </div>
          )
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default JobExpoPage;
